// @ts-expect-error
import numeral from 'numeral'

export function formatCurrency(value: null | number | string) {
  if (value == null || value === '') {
    return '–'
  }
  return numeral(value).format('$0,0')
}
